import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import {
    Dialog,
    ScreenMessagePanelContainer,
    FormFieldContainer,
    TextField,
    FormField,
    IconPath,
    Flexbox,
} from 'cw-ui-core';
import layoutCss from 'src/styles/layout.scss';
import Locale from 'src/i18n';
import css from './ViewEndpointsDialog.scss';
import TextButton from 'src/components/TextButton';
import IconButton from 'src/components/IconButton/IconButton';

export const VIEW_ENDPOINTS_DIALOG = 'VIEW_ENDPOINTS_DIALOG';

const ViewEndpointsDialog = ({
    intl,
    onDidMount,
    onClose,
    onCopyAuthEndpoint,
    onCopyTokenEndpoint,
    onCopyMetadata,
    openIdConfigUrl,
}) => {
    useEffect(() => {
        onDidMount();
    }, [onDidMount]);

    const { formatMessage } = intl;

    const dialogButtons = [
        <TextButton key="close" automationName="close" text={formatMessage(Locale.close)} onClick={onClose} />,
    ];

    return (
        <Dialog dialogId={VIEW_ENDPOINTS_DIALOG} header={formatMessage(Locale.endpoints)} buttons={dialogButtons}>
            <br />
            <div className={css.wrap}>
                <ScreenMessagePanelContainer className={css.screenMessage} screenKey={VIEW_ENDPOINTS_DIALOG} />
                <div className={layoutCss.podRow}>
                    <div className={layoutCss.podCol} style={{ flexGrow: 2 }}>
                        <Flexbox>
                            <FormFieldContainer
                                style={{ flexGrow: 1 }}
                                path={['openIdConfig', 'authorization_endpoint']}
                                label={formatMessage(Locale.authorizationEndpoint)}
                                screenKey={VIEW_ENDPOINTS_DIALOG}>
                                <TextField readOnly />
                            </FormFieldContainer>
                            <IconButton
                                style={{ marginTop: 24 }}
                                alt="Copy"
                                icon={IconPath.get('Action_Copy')}
                                onClick={onCopyAuthEndpoint}
                                automationName="copy_auth_endpoint"
                            />
                        </Flexbox>
                        <Flexbox>
                            <FormFieldContainer
                                style={{ flexGrow: 1 }}
                                path={['openIdConfig', 'token_endpoint']}
                                label={formatMessage(Locale.tokenEndpoint)}
                                screenKey={VIEW_ENDPOINTS_DIALOG}>
                                <TextField readOnly />
                            </FormFieldContainer>
                            <IconButton
                                style={{ marginTop: 24 }}
                                alt="Copy"
                                icon={IconPath.get('Action_Copy')}
                                onClick={onCopyTokenEndpoint}
                                automationName="copy_token_endpoint"
                            />
                        </Flexbox>
                        <Flexbox>
                            <FormField
                                style={{ flexGrow: 1 }}
                                path={[]}
                                value={openIdConfigUrl}
                                label={formatMessage(Locale.openIdConnectMetadataDocument)}
                                screenKey={VIEW_ENDPOINTS_DIALOG}>
                                <TextField readOnly />
                            </FormField>
                            <IconButton
                                style={{ marginTop: 24 }}
                                alt="Copy"
                                icon={IconPath.get('Action_Copy')}
                                onClick={onCopyMetadata}
                                automationName="copy_metadata"
                            />
                        </Flexbox>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default injectIntl(ViewEndpointsDialog);
